export const PERMISSION_CATEGORY_ORDER = [
  "dashboard",
  "notifications",
  "userProfile",
  "holidays",
  "adminSettings",
  "superAdminPanel",
  "holidayManagement", // Note: If this exists as separate from 'holidays'
  "attendance",
  "department",
  "program",
  "reports",
  "employees",
  "organization_management",
  "user_management",
  "configuration_management",
  "permission_management",
  "role_management",
  "ticket",
  "dashboardAccess",
];

export const sortPermissionsByCategory = (
  permissions: Record<string, unknown>
): Record<string, unknown> => {
  const sorted: Record<string, unknown> = {};

  // First, add permissions in the defined order
  PERMISSION_CATEGORY_ORDER.forEach((category) => {
    if (Object.hasOwn(permissions, category)) {
      sorted[category] = permissions[category];
    }
  });

  // Then, add any remaining permissions not in the defined order
  Object.entries(permissions).forEach(([key, value]) => {
    if (!Object.hasOwn(sorted, key)) {
      sorted[key] = value;
    }
  });

  return sorted;
};

export const sortSubPermissions = (
  category: string,
  subPermissions: Record<string, unknown>
): Record<string, unknown> => {
  // Define sub-permission order for specific categories
  const subOrderMap: Record<string, string[]> = {
    userProfile: [
      "view_profile",
      "update_profile",
      "update_personal_info",
      "update_employment_detail",
      "update_emergency_contact",
    ],
    attendance: ["viewSelf", "employee", "admin", "viewAll"],
    employees: [
      "viewProfile",
      "addleave",
      "department",
      "leaveEmployees",
      "adminLeave",
      "leaveConfiguration",
      "employeeleaveEdit",
      "adminleaveReject",
      "adminLeaveApproved",
      "userBalance",
      "balanceSummaryDownload",
    ],
    reports: [
      "leaveReports",
      "attendanceReports",
      "leaveHistoryReport",
      "leaveReportDownload",
      "attendancereportDownload",
    ],
    department: ["view", "add", "update", "delete"],
    dashboardAccess: [
      "view_department_dashboard",
      "view_supervisor_dashboard",
    ],
  };

  const subOrder = subOrderMap[category] || [];
  const sorted: Record<string, unknown> = {};

  // Add permissions in defined order
  subOrder.forEach((key) => {
    if (Object.hasOwn(subPermissions, key)) {
      sorted[key] = subPermissions[key];
    }
  });

  // Add remaining permissions not in the defined order
  Object.entries(subPermissions).forEach(([key, value]) => {
    if (!Object.hasOwn(sorted, key)) {
      sorted[key] = value;
    }
  });

  return sorted;
};

export const getSortedPermissions = (
  permissions: Record<string, unknown>
): Record<string, unknown> => {
  const sorted = sortPermissionsByCategory(permissions);

  // Also sort sub-permissions within each category
  Object.entries(sorted).forEach(([category, value]) => {
    if (typeof value === "object" && value !== null) {
      sorted[category] = sortSubPermissions(category, value as Record<string, unknown>);
    }
  });

  return sorted;
};
